import { notifications } from '@mantine/notifications'


type Notification = {
    title: string;
    message: string;
    position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
    color?: string;
};

export const notify = (title: string, message: string, color?: string) => {
  let notification: Notification = { title: title, message: message, position: 'top-right' };

  if (color) {
    notification = { ...notification, color: color };
  }

  notifications.show(notification);
};